import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300" />}
        </span>
      ))}
    </nav>
  );
}